<div *ngIf="isLoaded">
  <hb-dynamic-auto-complete-double [control]="equipmentClassControl" [formGroup]="formGroup"> </hb-dynamic-auto-complete-double>
  <hb-dynamic-auto-complete-double [control]="equipmentTypeControl" [formGroup]="formGroup"> </hb-dynamic-auto-complete-double>
  <hb-dynamic-auto-complete [control]="equipmentSubUnitDropdown" [formGroup]="formGroup"> </hb-dynamic-auto-complete>
  <hb-dynamic-auto-complete [control]="equipmentComponentDropdown" [formGroup]="formGroup"> </hb-dynamic-auto-complete>
  <hb-dynamic-auto-complete [control]="equipmentPartDropdown" [formGroup]="formGroup"> </hb-dynamic-auto-complete>
</div>
